import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { AddressValidationResponseDto } from 'src/app/model/account/address-validation-response.dto';
import { ContractContactDetails } from 'src/app/model/account/user-otp-request';
import { ValidateOtpResponseDtoV0 } from 'src/app/modules/onboarding/components/create-account-v0/create-account.component';

@Injectable({
  providedIn: 'root'
})
export class AddressValidationService {
  url: string;

  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private httpClient: HttpClient
  ) { 
    this.url = this.preInitSettingsService.getSettings().middleWare.middlewareUrl + this.preInitSettingsService.getSettings().middleWare.accountPath;
  }

  validateAddress(address: ContractContactDetails | ValidateOtpResponseDtoV0): Observable<AddressValidationResponseDto> {
    return this.httpClient.post<AddressValidationResponseDto>(this.url + 'validate-address', address);
  }

  saveAddress(address: ContractContactDetails | ValidateOtpResponseDtoV0): Observable<AddressValidationResponseDto> {
    return this.httpClient.post<AddressValidationResponseDto>(this.url + 'save-address', address);
  }
}
